import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import type { FilterOption } from '@models/Filter'

import { SelectObject } from '../../../../core/components/SelectObject'
import { useProjectSelectlists } from '../../../../selectlists/hooks/useProjectSelectlists'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { HoofdleidingProject } from '../../types/HoofdleidingProject'

interface Props {
  project: HoofdleidingProject
  handleClose: () => void
}

export const Gebiedswissel = ({ project, handleClose }: Props) => {
  const { mutate: saveEvent } = useSaveEvent()
  const { data: selectlists } = useProjectSelectlists({
    id: project.aanvraagID,
  })
  const [gebied, setGebied] = useState<FilterOption | null>(null)

  const handleSubmitClick = () => {
    saveEvent(
      {
        id: project.aanvraagID,
        data: {
          // @ts-expect-error - kan niet null zijn want button staat uit als dat het geval is
          gebiedscode: gebied.code,
          sourceGebiedscode: project.gebiedscode,
        },
        type: 'hoofdleiding_gebiedswissel',
        source: 'manual',
      },
      {
        onSuccess: () => handleClose(),
      },
    )
  }

  return (
    <>
      <DialogTitle>Wijzigen gebied</DialogTitle>
      <DialogContent>
        <SelectObject
          options={(selectlists.gebieden ?? []).filter(
            (g) => g.code !== project.gebiedscode,
          )}
          value={gebied}
          onChange={setGebied}
          label="Gebied"
          getOptionLabel={(g) => `${g.code} - ${g.label}`}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Annuleren
        </Button>
        <Button color="primary" onClick={handleSubmitClick} disabled={!gebied}>
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
